<div class="modal"
     [ngClass]="{'show' :config.showTrialCode}">
  <div class="modal-content">
    <div class="modal-content__body-container">
      <div class="modal-header" #modalHeader>
        <h3 [translate]="titleKey" class="no-margin-buttom"></h3>
      </div>
      <p [translate]="descriptionKey"></p>
      <form>
        <div>
          <app-input-trial-code [invalidTrialCode]="!isCodeValid" [x]="0" [y]="0" [ownerComponent]="ownerComponent"
                                (emitOnEnterPressed)="retrieveTrialSalesOffers()"></app-input-trial-code>
        </div>
      </form>
      <div *ngFor="let reason of unavailableReasons;">
        <span class="errorText">{{ reason }} </span>
      </div>
      <span [hidden]="isCodeValid || unavailableReasons?.size > 0" class="errorText">{{voucherErrorCode | translate}} </span>
      <span [hidden]="isCodeValid || !attemptsRemaining || unavailableReasons?.size > 0" class="errorText"
            [translate]="'eos-tv-shop-ii.error.trial-invalid-attempts-remaining'"
            [translateParams]="{ attemptsRemaining: attemptsRemaining }"></span>
      <p class="info w90" [translate]="'eos-tv-shop-ii.text.input-code-modal-info'"></p>
      <div class="column">
        <app-navigable-button [x]="0" [y]="1" class="btn btn-grey-large marginBottom15" #confirm [widthPercentage]="95"
                              [ownerComponent]="ownerComponent"
                              (emitOnEnterPressed)="retrieveTrialSalesOffers()" (emitOnBack)="onBack()">
          <span [translate]="'eos-tv-shop-ii.btn.confirmation'"></span>
        </app-navigable-button>
        <app-navigable-button [x]="0" [y]="2" class="btn btn-grey-large" #conditions [ownerComponent]="ownerComponent"
                              [widthPercentage]="95"
                              (emitOnEnterPressed)="openConditional()" (emitOnBack)="onBack()">
          <span [translate]="'eos-tv-shop-ii.lbl.input-pincode-modal-watch-conditions'"></span>
        </app-navigable-button>
      </div>
    </div>
    <app-spinner-modal [loading]="!doneLoading"></app-spinner-modal>
  </div>
</div>
